import { render, staticRenderFns } from "./RepoNameDocs.vue?vue&type=template&id=aa4eb50e&scoped=true&"
import script from "./RepoNameDocs.vue?vue&type=script&lang=js&"
export * from "./RepoNameDocs.vue?vue&type=script&lang=js&"
import style0 from "./RepoNameDocs.vue?vue&type=style&index=0&id=aa4eb50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4eb50e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VIcon,VSheet})
